import React, { useState } from "react";
import { userSchema } from "./validation";
import { useForm } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";

import Signlogo from "../logo-sign.svg";
import axios from "axios";
import { useHistory } from "react-router";
import Loader from "react-loader-spinner";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

function Test() {
  const history = useHistory();
  const [isloading, setLoading] = useState(false);
  const [idOffice, setId] = useState();
  const signinError = () =>
    toast.info("Invalid Credentials", {
      position: "top-center",
      pauseOnHover: false,
    });

  const HandleForm = (data) => {
    const headers = {
      "Content-Type": "application/json",
    };

    setLoading(true);
    axios
      .post("https://app.digitaezproducts.com/api/v1/auth/login", data, {
        headers: headers,
      })
      .then((res) => {
        //console.log("Response =>", res);

        //history.push('/attendance');
        setLoading(false);

        setId(res.data.user._id);

        localStorage.setItem("token", res.data.token);
        // navigate('/attendance')
        history.push("/attendance");
      })

      .catch((err) => {
        // console.log("hererere:::", err);
        signinError();
        setLoading(false);
      });
  };

  // axios.post('https://digitaezoffice.herokuapp.com/api/v1/auth/login',data,{headers:headers})

  const {
    register,
    handleSubmit,
    formState: { errors },
  } = useForm({
    resolver: yupResolver(userSchema),
  });

  return (
    <>
      <h1>Test</h1>

      <div className="container-fluid">
        <div class="row">
          <div class="col-12">
            <img src={Signlogo} alt="" />
          </div>
        </div>

        <form onSubmit={handleSubmit(HandleForm)}>
          <div className="sign-forms">
            <div className="error-hndl">
              <input
                type="text"
                id="email"
                name="email"
                className="form-control mt-2 form-rounded signform"
                placeholder="Enter Your Email"
                autoComplete="off"
                {...register("email")}
              />
            </div>
            <div className="error-hndl">
              <input
                type="password"
                id="password"
                name="password"
                className="form-control mt-2 form-rounded signform"
                placeholder="Enter Your Password"
                autoComplete="off"
                {...register("password")}
              />

              <p className="error-msg">{errors.email?.message}</p>
            </div>
          </div>
          <div>
            <input
              type="submit"
              className="sign-inbtn justify-content-center shadow-sm mt-4"
            ></input>
          </div>
          {isloading ? (
            <Loader
              className="loader"
              type="Oval"
              color="#2cb9cf"
              height={50}
              width={50}
            />
          ) : (
            " "
          )}
          {/* <Loader className="loader" type="Oval" color="#2cb9cf" height={50} width={50}/>   */}
        </form>
        <div></div>
      </div>

      <ToastContainer />
    </>
  );
}

export default Test;
